import Image from 'next/image'
import React from 'react'

interface CustomImageRendererProps {
  src?: string
  alt?: string
}

export const CustomImageRenderer: React.FC<CustomImageRendererProps> = ({
  src,
  alt
}) => {
  return (
    <>
      {src === 'placeholder' ? (
        <div className="image-placeholder">
          {/* Placeholder spinner or skeleton */}
          <div className="spinner">Loading Image...</div>
        </div>
      ) : (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={src} alt={alt} />
      )}
    </>
  )
}
